/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Permission_Search_PlaceholderInputs */

const fr_permission_search_placeholder = /** @type {(inputs: Permission_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher une permission...`)
};

/**

* @param {Permission_Search_PlaceholderInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const permission_search_placeholder = /** @type {((inputs?: Permission_Search_PlaceholderInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Permission_Search_PlaceholderInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_permission_search_placeholder(inputs)
});